import Axios from 'axios';

import {
	HELPER_STATS_LOADING,
	HELPER_STATS_HOURLY_GET,
	HELPER_STATS_HOURLY_ERROR,
	HELPER_STATS_DAILY_GET,
	HELPER_STATS_DAILY_ERROR,
	HELPER_STATS_CURRENT_GET,
	HELPER_STATS_CURRENT_ERROR,
	HELPER_STATS_PERFORMANCE_GET,
	HELPER_STATS_PERFORMANCE_ERROR,
	HELPER_STATS_SUMMARY_GET,
	HELPER_STATS_SUMMARY_ERROR,
	HELPER_STATS_PEAK_GET,
	HELPER_STATS_PEAK_ERROR,
	HELPER_STATS_COMPARISON_GET,
	HELPER_STATS_COMPARISON_ERROR,
	HELPER_STATS_ANOMALIES_GET,
	HELPER_STATS_ANOMALIES_ERROR
} from './types';

export const get_helper_stats_hourly = (instance_id, hours = 24) => dispatch => {
	dispatch({ type: HELPER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/stats/hourly?hours=${hours}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: HELPER_STATS_HOURLY_GET, payload: res.data });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: HELPER_STATS_HOURLY_ERROR, payload: { type: 'helper_stats_hourly', msg: err.message } });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	})
}

export const get_helper_stats_daily = (instance_id, start, end) => dispatch => {
	dispatch({ type: HELPER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/stats/daily?start=${start}&end=${end}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: HELPER_STATS_DAILY_GET, payload: res.data });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: HELPER_STATS_DAILY_ERROR, payload: { type: 'helper_stats_daily', msg: err.message } });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	})
}

export const get_helper_stats_current = (instance_id, minutes = 5) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/stats/current?minutes=${minutes}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: HELPER_STATS_CURRENT_GET, payload: res.data });
	}).catch((err) => {
		dispatch({ type: HELPER_STATS_CURRENT_ERROR, payload: { type: 'helper_stats_current', msg: err.message } });
	})
}

export const get_helper_stats_performance = (instance_id) => dispatch => {
	dispatch({ type: HELPER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/stats/performance`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: HELPER_STATS_PERFORMANCE_GET, payload: res.data });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: HELPER_STATS_PERFORMANCE_ERROR, payload: { type: 'helper_stats_performance', msg: err.message } });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	})
}

export const get_helper_stats_summary = (instance_id) => dispatch => {
	dispatch({ type: HELPER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/stats/summary`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: HELPER_STATS_SUMMARY_GET, payload: res.data });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: HELPER_STATS_SUMMARY_ERROR, payload: { type: 'helper_stats_summary', msg: err.message } });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	})
}

export const get_helpers_stats_peak = (days = 7) => dispatch => {
	dispatch({ type: HELPER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/stats/peak?days=${days}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: HELPER_STATS_PEAK_GET, payload: res.data });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: HELPER_STATS_PEAK_ERROR, payload: { type: 'helper_stats_peak', msg: err.message } });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	})
}

export const get_helpers_stats_comparison = (helperIds, hours = 24) => dispatch => {
	dispatch({ type: HELPER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/stats/comparison?helpers=${helperIds}&hours=${hours}`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: HELPER_STATS_COMPARISON_GET, payload: res.data });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: HELPER_STATS_COMPARISON_ERROR, payload: { type: 'helper_stats_comparison', msg: err.message } });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	})
}

export const get_helper_stats_anomalies = (instance_id) => dispatch => {
	dispatch({ type: HELPER_STATS_LOADING, payload: true });

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/stats/anomalies`;

	Axios.get(url)
	.then((res) => {
		dispatch({ type: HELPER_STATS_ANOMALIES_GET, payload: res.data });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	}).catch((err) => {
		dispatch({ type: HELPER_STATS_ANOMALIES_ERROR, payload: { type: 'helper_stats_anomalies', msg: err.message } });
		dispatch({ type: HELPER_STATS_LOADING, payload: false });
	})
}
